import { gql } from 'apollo-angular';

export const TIME_ENTRY_CATEGORY_SUM_QUERY = gql`
query TimeEntryCategorySumQuery(
  $ownerId: UUID
)
{
  timeEntryCategoriesSum: getTimeEntryCategoriesSum(
    filter: {
      ownerId: $ownerId
  }){
    category{
        id
        name
    }
    sum
  }
}
`;

export interface TimeEntrCategoriesSumQueryResponse {
  timeEntryCategoriesSum: any;
  loading: boolean;
}


